import { useIntl } from 'react-intl';
import './BreadcrumbsHierarquia.css';

const BreadcrumbsHierarquia = ({ categoria }) => {
  const intl = useIntl();
  const construirCaminho = (cat) => {
    const caminho = [];
    let atual = cat;

    while (atual) {
      caminho.unshift(atual);
      atual = atual.pai;
    }

    return caminho;
  };

  const caminho = construirCaminho(categoria);

  return (
    <div className="breadcrumbs-hierarquia">
      <span className="breadcrumbs-label">{intl.formatMessage({id: 'labelLocalizacao'})}: </span>
      {caminho.map((cat, index) => (
        <span key={cat.id} className="breadcrumb-item">
          {index > 0 && <span className="separator"></span>}
          <span
            className={`breadcrumb-text ${
              index === caminho.length - 1 ? 'current' : ''
            }`}
          >
            {cat.nome}
          </span>
        </span>
      ))}
    </div>
  );
};

export default BreadcrumbsHierarquia;
